import { Grid, makeStyles } from '@material-ui/core';
import styles from './styles';
import HomeFooter from '../../components/Footer/HomeFooter';
import Header from '../Header';

const CSLayout = (props) => {
  const useStyles = makeStyles(styles);
  const classes = useStyles();

  return (
    <Grid container className={classes.root}>
      <Header infoBanner />
      {props.children}
      <Grid container className={classes.footerContainer}>
        <HomeFooter />
      </Grid>
    </Grid>
  );
};

export default CSLayout;
